import { NgModule } from '@angular/core';
import { AbbreviateNumberPipe } from './pipes/abbreviateNumber.pipe';


@NgModule({
  declarations: [
    AbbreviateNumberPipe
  ],  
  exports: [
    AbbreviateNumberPipe   
  ]
})
export class AbbreviateNumberModule { }

